import { useNavigate } from "react-router-dom";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f8f5f0] flex flex-col items-center justify-center px-5">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <h1 className="text-[120px] md:text-[140px] font-black text-[#1a3a5c] leading-none select-none">404</h1>
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-[#1a3a5c] mb-3">页面未找到</h2>
        <p className="text-sm text-gray-500 mb-8 leading-relaxed">
          您访问的页面不存在或已被移除，请检查链接是否正确。
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 bg-[#1a3a5c] text-white rounded-full text-sm font-medium hover:bg-[#142d48] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-home-line"></i>返回首页
          </button>
          <button
            onClick={() => navigate(-1 as any)}
            className="px-6 py-3 bg-white border border-gray-200 text-[#1a3a5c] rounded-full text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-arrow-left-line"></i>返回上页
          </button>
        </div>
      </div>
      <footer className="mt-16 text-center">
        <p className="text-[11px] text-gray-400">RTB 试管助孕中心</p>
        <p className="text-[10px] text-gray-300 mt-0.5">客户全周期管理 CRM 系统</p>
        <p className="text-[10px] text-gray-300 mt-1">&copy; 2025 RTB Fertility. All Rights Reserved.</p>
      </footer>
    </div>
  );
}